import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '~/services/queryClient'
import { getEDIFactCodes } from '~/services/staticService'

export interface EDIFactCodes {
  [key: string]: string[]
}

export function useEDIFactCodes() {
  return useQuery<EDIFactCodes>({
    queryKey: QueryKeys.EDIFactCodes,
    queryFn: getEDIFactCodes
  })
}
